import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  ADMIN_LEADERBOARD_ALLOWED_PATHS,
  TRANSACTION_HOME_PATH,
  isAdminLeaderboardRole,
  isAdminRole,
  isAdminOnlyPath,
  isCashierOrFloorSupervisor,
  isManagementOnlyPath,
} from '../constants/roles';
import { isPathAllowedByPermissions, SIDEBAR_TABS } from '../constants/sidebarTabs';

const RoleProtectedRoute = ({ children }) => {
  const location = useLocation();
  const userData = localStorage.getItem('user');

  if (!userData) {
    return children;
  }

  try {
    const parsed = JSON.parse(userData);
    const { role, permissions } = parsed;

    if (isAdminRole(role)) {
      return children;
    }

    // Dynamic Permission check: If dynamic permissions object is present and populated
    if (permissions && typeof permissions === 'object' && Object.keys(permissions).length > 0) {
      const isAllowed = isPathAllowedByPermissions(location.pathname, permissions, role);
      if (!isAllowed) {
        const allowedTab = SIDEBAR_TABS.find((t) => permissions[t.key] === true && Boolean(t.href));
        const fallback = allowedTab?.href || (permissions['promos'] ? TRANSACTION_HOME_PATH : '/tournament-leaderboard');
        if (location.pathname === fallback) {
          return children;
        }
        return <Navigate to={fallback} replace />;
      }
      return children;
    }

    // Admin-only paths: strictly accessible by Admin only
    if (isAdminOnlyPath(location.pathname) && !isAdminRole(role)) {
      return <Navigate to={isCashierOrFloorSupervisor(role) ? TRANSACTION_HOME_PATH : '/'} replace />;
    }

    if (isAdminLeaderboardRole(role)) {
      const isAllowed = ADMIN_LEADERBOARD_ALLOWED_PATHS.some(
        (path) =>
          location.pathname === path ||
          location.pathname.startsWith(`${path}/`)
      );

      if (!isAllowed) {
        return <Navigate to="/tournament-leaderboard" replace />;
      }
    }

    // Cashier & Floor Supervisor: Transactions + EPL Players only (no Management)
    if (isCashierOrFloorSupervisor(role) && isManagementOnlyPath(location.pathname)) {
      return <Navigate to={TRANSACTION_HOME_PATH} replace />;
    }
  } catch (error) {
    console.error('Error parsing user data for role check:', error);
  }


  return children;
};

export default RoleProtectedRoute;
